
export const PublicSellerCareQuery = new TypedDocumentString(`
    query PublicSellerCareQuery($sellerId: ObjectId!) {
  publicSellerCareIcons(sellerId: $sellerId) {
    ...ProductExtraCareIcon
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductExtraCareIcon on ProductExtraCareIcon {
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  __typename
}`, {"hash":"0d3377a5bff49ba9d2095bc66b191109ce620c67959c2527d5ecf9dd755d1e45"});